module.exports = __webpack_public_path__ + "static/media/decline.900d4b66.svg";